export const formOptions = [
  { label: '企业名称', prop: 'companyName', type: 'input', typeOptions: { placeholder: '不超过32个字符', maxlength: 32 }},
  { label: '企业简称', prop: 'companyAbbreviation', type: 'input', typeOptions: { placeholder: '不超过16个字符', maxlength: 16 }},
  { label: '企业LOGO', prop: 'logo', type: 'upload', canRecover: true },
  { label: '顶部栏背景颜色', prop: 'bannerColor', type: 'color-picker', typeOptions: { size: 'medium' }, canRecover: true, rules: { required: true, message: '顶部栏背景颜色不能为空', trigger: ['blur', 'change'] }},
  { label: '文本颜色', prop: 'textColor', type: 'color-picker', typeOptions: { size: 'medium' }, canRecover: true, rules: { required: true, message: '文本颜色不能为空', trigger: ['blur', 'change'] }}
]

